import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Offers = ({ name = "" }) => {
  const [offerList, setOfferList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the list of offers from the server
  const loadOffers = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "offer" });
    // const response = await getCampaigns({ token, type: "offer" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((offer: any) => {
          return {
            id: offer.id,
            label: offer.name,
            caption: `Last Updated: ${moment(offer.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setOfferList(seqs);
    }
    setIsLoading(false);
  };

  // load the offerList when the page loads
  useEffect(() => {
    loadOffers();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/offers" className="justify-end">
            <Button label="+ Create an Offer" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(offerList.length) && (
          <EmptyState
            title="No Offers Yet"
            description="Get started by creating a new offer."
            showImage={false}
          >
            <Link to="/launchpad/offers">
              <Button label="Create an Offer" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(offerList.length) && (
          <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {offerList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/offers/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
